import React from "react";
import { DrawerContext } from "@src/screens/drawer-screens/drawer-provider";
import { getActiveIndex } from "@src/utils/filter-helper";
import { LiveSignRequestSteps, LiveSendRequestSteps } from "@src/utils/mockdata";
import SendButton from "./send-button";
import useStyles from "./styles.css";
import { View } from "react-native";
import Items from "./items";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectedDraftDocument } from "@src/ducks/slices/signsecure.slice";

const CDStepsHeader = () => {
  const styles = useStyles();
  const { steps, activeDocument, doneDocument, onSetCreateDocumentScreen } = React.useContext(DrawerContext);
  const activeIndex = React.useMemo(() => getActiveIndex(activeDocument), [activeDocument]);  
  const doneIndex = React.useMemo(() => getActiveIndex(doneDocument), [doneDocument]);  
  const document = useAppSelector(selectedDraftDocument);
  let isDraft = false
  if (document && document.files) {
    isDraft = document?.files[0]?.isDraft;
  }
  
  return (
    <View style={styles.container}>
      <View style={styles.steps_container}>
        {(steps.includes("Sign") ? LiveSignRequestSteps : LiveSendRequestSteps).map((item, index) => {
          return (
            <Items
              key={`stepIdx${index}`}
              item={item}
              disabled={!((doneIndex >= index && doneDocument.includes(item) || doneIndex > index) || activeIndex > index )}
              isActive={isDraft ? false : activeIndex === index}
              isDraft={false}
              isDone={((doneIndex >= index && doneDocument.includes(item) || doneIndex > index) || activeIndex > index )}
              onPress={() => () => {}}//onSetCreateDocumentScreen(item)}
            />
          );
        })}
      </View>
      {/* <SendButton /> */}
    </View>
  );
};

export default React.memo(CDStepsHeader);
